import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { setLocation } from '../../../redux/actions';
import Maps from '../../master/Maps';

export default function CompleteMap({ changeStep, onFinish }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { location } = useSelector(store => store);

    function changeLocation(e) {
        dispatch(setLocation({
            lat: e.lat,
            lng: e.lng,
        }));
    }

    return(
        <div className='complete-content maps'>
            <p className='mb20'>{t('Select your location')}</p>
            <Maps
                loc={[
                    location.lat,
                    location.lng,
                ]}
                changeLocation={changeLocation}
            />
            <div className='nav-button-parent'>
                <button className='navButton' style={{marginRight:5}} onClick={() => onFinish(location)}>
                    {t('Submit')}
                    <i className='fas fa-chevron-down' />
                </button>
                <button className='navButton prev' style={{marginLeft:5}} onClick={() => changeStep(3)}>
                    {t('Prev step')}
                    <i className='fas fa-chevron-up' />
                </button>
            </div>
        </div>
    )
}
